const FilmGrain = () => {
  return <div className="film-grain" />;
};

export default FilmGrain;